<template>
	<div id="app">
		<keep-alive>
			<router-view></router-view>
		</keep-alive>
	</div>
</template>

<script>
	export default {
		name: 'app'
	}
</script>

<style>

	html,
	body {
		height: 100%;
		width: 100%;
		margin: 0;
		overflow: hidden;
		font-size: 12px;
		color: #333;
	}
	
	.page{
		width: calc(100% - 40px);
		background: #fff;
		border-radius: 10px;
		padding: 10px 20px;
		min-height: calc(100% - 40px);
	}

	#app {
		height: 100%;
		width: 100%;
	}

	/* 定义全局的css变量 */
	:root {
		/* 背景色(主色) */
		--theme-color: #00A292;
		--theme-color1: rgba(0, 162, 146, 0.1);
		--theme-color2: rgba(0, 162, 146, 0.2);
		--theme-color3: rgba(0, 162, 146, 0.3);
		--theme-color5: rgba(0, 162, 146, 0.5);
		--theme-color7: rgba(0, 162, 146, 0.7);
		/* 背景色(辅助色) */
		--auxiliary-color: #000000;
	}
</style>